<template>
  <main id="content">
    <div class="l-main-content__inner">
      <div class="c-page-header">
        <h1 class="c-page-header-title">進級処理</h1>
        <div class="c-page-header__return">
          <a
            :href="`/teacher/class/?academic_session_year=${targetAcademicSessions?.from_academic_session.year}`"
            class="c-button-white -return -teacher">
            <span class="label">戻る</span>
          </a>
        </div>
      </div>
      <template v-if="canNextGrade">
        <template v-if="fromAcademicYearsStudentsRegistrationStatus">
          <p class="c-page-explanation -attention">
            この画面では生徒の進級処理（新年度の学年・学級の登録）を行います。<br>
            進級処理を行う学年を選択し、進級処理の方法をお選びください。<br>
            ※手順については<a href="https://manavi.wikipy.jp/teacher/p712" target="_blank">コチラ</a>をご参照ください。
          </p>
          <section v-if="isStudentsRegisteredInAnyFromAcademicYear">
            <!-- 対象学年ラジオボタン -->
            <div class="c-page-section">
              <div class="c-parts-description">
                <div class="c-parts-description__label">
                  <span class="label">対象学年</span>
                </div>
                <div class="c-parts-description__content">
                  <form class="p-grade-radio-area" id="gradeSelect">
                    <label
                      v-for="status in fromAcademicYearsStudentsRegistrationStatus"
                      :key="status.academic_year"
                      class="p-grade-radio"
                      :for="`grade${status.academic_year}`"
                    >
                      <input type="radio"
                        name="grade"
                        :value="status.academic_year"
                        :id="`grade${status.academic_year}`"
                        class="p-grade-radio__input"
                        v-model="selectedFromAcademicYear"
                        :disabled="!status.is_registered"
                        @change="onSelectedFromAcademicYearChange"
                      >
                      <span
                        :class="{'p-grade-radio__label': true, '-disabled': !status.is_registered}"
                      >{{ targetAcademicSessions.from_academic_session.year }}年度 {{ status.academic_year }}年生</span>
                    </label>
                  </form>
                </div>
              </div>
            </div>

            <p :class="{'p-grade-target-text': true, 'display': selectedFromAcademicYear}">
              <span id="from-target-grade" class="target-year">{{ targetAcademicSessions.from_academic_session.year }}年度 {{ selectedFromAcademicYear }}年生</span>を
              <span id="to-target-grade" class="target-year">{{ targetAcademicSessions.to_academic_session.year }}年度 {{ selectedToAcademicYear }}年生</span>にする処理を行います
            </p>

            <div :class="{'c-page-section p-grade-method': true, 'display': selectedFromAcademicYear}">
              <div class="c-parts-box -white">
                <h2 class="p-grade-method-title">
                  進級処理の方法を選択してください
                </h2>
                <table class="c-table-no-rounded">
                  <tbody>
                    <tr>
                      <th></th>
                      <th class="title -teacher"><strong>先生</strong>が名簿データを作成</th>
                      <th class="title -student"><strong>生徒</strong>が学級・出席番号を入力</th>
                    </tr>
                    <tr>
                      <th class="subtitle">
                        進級処理の<br>正確性
                      </th>
                      <td class="circle">全ての生徒を<strong>正しく進級可能</strong></td>
                      <td class="triangle">
                        生徒が間違える場合あり
                        <span class="small">（先生の確認と、誤りの修正が必要）</span>
                      </td>
                    </tr>
                    <tr>
                      <th class="subtitle">
                        名簿データ（Excel）<br>の作成
                      </th>
                      <td class="triangle">名簿データ（Excel）のダウンロード、修正、アップロードが必要</td>
                      <td class="circle">名簿データ（Excel）の<strong>作成不要</strong></td>
                    </tr>
                    <tr>
                      <th class="subtitle">
                        進級処理の<br>正確性
                      </th>
                      <td class="circle">進級処理後、<strong>すぐに宿題の配信可能</strong></td>
                      <td class="triangle">
                        宿題を配信できない場合あり
                        <span class="small">（すべての生徒が進級処理を完了すれば配信可能）</span>
                      </td>
                    </tr>
                    <tr>
                      <th class="subtitle"></th>
                      <td class="button">
                        <a
                            :href="`${selectedToAcademicYear}/by_teacher`"
                            class="c-button-blue -small-regular"
                        >
                          <span class="label">先生が名簿データを作成</span>
                        </a>
                      </td>
                      <td class="button">
                        <a
                            :href="`${selectedToAcademicYear}/by_student`"
                            class="c-button-blue -small-regular"
                        >
                          <span class="label">生徒が学級・出席番号を入力</span>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <div
            v-else
            class="c-frame-message"
          >
            <p class="c-parts-error-message -center">
              {{ targetAcademicSessions.from_academic_session.year }}年度に進級処理が可能な生徒の登録がありません。<br>
              詳しくは
              <a
                href="https://manavi.wikipy.jp/teacher/p712"
                target="_blank"
                class="c-parts-link"
              >サポートページ</a>
              を参照してください。
            </p>
          </div>
        </template>
      </template>

      <div
        v-else
        class="c-frame-message"
      >
        <p class="c-parts-error-message -center">
          {{ academicSessionYear }}年度は、現在進級処理できない年度です。現在進級処理できるのは、{{ targetAcademicSessions?.from_academic_session.year }}年度の生徒です。<br>
          詳しくは
          <a
            href="https://manavi.wikipy.jp/teacher/p712"
            target="_blank"
            class="c-parts-link"
          >サポートページ</a>
          を参照してください。
        </p>
      </div>
    </div>
    <error-modal></error-modal>
  </main>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted } from "vue";
  import { ITargetAcademicSessions, IStudentsRegistrationStatus } from "@/consts/interfaces";
  import { useNextGradeStore } from "@/store/teacher/next_grade_store";

  const nextGradeStore = useNextGradeStore()

  const props = defineProps<{
    academicSessionYear: number,
  }>();

  // 進級元学年の選択肢一覧 (3年生は進級しないため、1年生・2年生のみ)
  const fromAcademicYearOptions = ref([1, 2])

  // 進級対象年度(進級元年度/進級先年度)
  const targetAcademicSessions =  ref<ITargetAcademicSessions>(null);
  // 進級元学年の生徒登録状況一覧
  const fromAcademicYearsStudentsRegistrationStatus = ref<Array<IStudentsRegistrationStatus>>(null);

  // 先生が選択した進級元学年
  const selectedFromAcademicYear = ref<number>(null);
  // 先生が選択した進級元学年の進級先学年
  const selectedToAcademicYear = computed(() => {
    return selectedFromAcademicYear.value + 1
  })

  // 進級可能な年度である
  const canNextGrade = ref<boolean>(true);
  // 進級元のいずれかの学年に生徒が登録されている
  const isStudentsRegisteredInAnyFromAcademicYear = computed(() => {
    return fromAcademicYearsStudentsRegistrationStatus.value.some(
        status => status["is_registered"]
    )
  })

  onMounted(async() => {
    targetAcademicSessions.value = await nextGradeStore.fetchAcademicSessions()

    if (targetAcademicSessions.value.from_academic_session.year !== props.academicSessionYear) {
      canNextGrade.value = false
      return
    }

    const fromStudentsRegistrationStatus = await nextGradeStore.fetchStudentsRegistrationStatus(
      {
        academic_session: targetAcademicSessions.value.from_academic_session.id,
      }
    )
    fromAcademicYearsStudentsRegistrationStatus.value = fromStudentsRegistrationStatus.filter(
        status => fromAcademicYearOptions.value.includes(status["academic_year"])
    )
  })

  // 対象学年ラジオボタン切り替え時
  function onSelectedFromAcademicYearChange() {
    const fromTargetGrade = document.getElementById("from-target-grade")
    const toTargetGrade = document.getElementById("to-target-grade")

    // 進級対象年度・学年の下線を一旦非表示
    fromTargetGrade.classList.remove("display")
    toTargetGrade.classList.remove("display")

    // 500ミリ秒後に表示
    setTimeout(() => {
      fromTargetGrade.classList.add("display")
      toTargetGrade.classList.add("display")
    }, 500)
  }

</script>
